import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Venta } from 'src/app/model/index.model';
import { VentaService } from 'src/app/service/index.service';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';

@Component({
  selector: 'app-fil-venta-usuario',
  templateUrl: './fil-venta-usuario.component.html',
  styleUrls: ['./fil-venta-usuario.component.css']
})
export class FilVentaUsuarioComponent implements OnInit {

  @Output()
  filter: EventEmitter<Venta[]> = new EventEmitter<Venta[]>();

  proccess: Boolean;
  public search: string;
  public oldSearch: string;

  /* Searcheable table Filter */
  public limit: number;
  public page: number;
  public nextPage: number;
  public prevPage: number;
  public lastPage: number;
  public count: number;
  public limits: number[] = [5, 10, 25, 50, 100];

  setPage(page) {
    this.page = page;
    this.list()
  }

  constructor(private wsdl: VentaService) {
    this.proccess = false;
    this.limit = 5;
    this.page = 1;
    this.search = JSON.parse(UturuncoUtils.getSession("user")).id;

  }

  ngOnInit() {
    this.list()
  }

  async list() {
    this.proccess = true;

    if (this.search === undefined) {
      this.search = "";
    }
    let d = this.oldSearch !== this.search;
    if (d) {
      this.limit = 5;
      this.page = 1;
      this.oldSearch = this.search;
    }

    let c = this.search;
    let data = await this.wsdl.doFindByUsuario(c, this.page, this.limit).then();
    const result = JSON.parse(JSON.stringify(data));
    console.log(result)
    if (result.code == 200) {
      this.filter.emit(result.data.docs);

      this.page = parseInt(result.data.paginate.page)
      this.lastPage = parseInt(result.data.paginate.lastPage)
      this.nextPage = parseInt(result.data.paginate.nextPage)
      this.prevPage = parseInt(result.data.paginate.prevPage)
      this.count = parseInt(result.data.paginate.count)

    } else if (result.code === 401) {
      // logout app o refresh token

    } else {
      this.filter.emit([]);
      UturuncoUtils.showToas(result.msg, "error");
    }
    this.proccess = false;

  }

}
